module.exports = __webpack_public_path__ + "img/zhaji.png";